import React from "react";
import "./Display.css";

const Display = ({ data }) => {
  return (
    <div className="Display">
        {data}
    </div>
  );
};

export default Display;
